import { useDsModalStore } from "../components/modal/DsModalStore";

export class DsModalHandler {
  static open(id = "modal"): void {
    useDsModalStore().beforeOpen(id);
    useDsModalStore().open({
      show: true,
      id,
    });
  }

  static close(id = "modal"): void {
    useDsModalStore().beforeClose(id);
    useDsModalStore().close(id);
  }

  static closeAll(): void {
    useDsModalStore().closeAll();
  }
}
